<template>
  <!--核销二维码-->
  <Popup v-model="openPopup" :round="true" :style="modalCss">
    <div class="qrcode">
      <canvas id="canvas"></canvas>
    </div>
    <p class="qrcode-text">请工作人员进行扫码核销</p>
  </Popup>
</template>

<script>
  import { Popup } from 'vant';
  import QRCode from 'qrcode';
  export default {
    name: 'verificationQrcode',
    components: {
      Popup
    },
    props: {
    },
    data() {
      return {
        openPopup: false,
        modalCss: {
          "min-width": '200px',
          "min-height": '200px'
        }
      }
    },
    methods: {
      open(type, item) {
        this.openPopup = true;
        let params = {};
        if (type === 1 || type === 2) {
          params.id = item.orderItemId; // 子订单id
          params.type = 'spike'; // 秒杀下订公用
        }
        else if(type === 3) {
          params.id = item.id; // 优惠券id
          params.userAccountId = this.$fission.user.userAccountId;
          params.type = 'coupon';
        }else if (type === 4) {
          params.id = item.orderItemId; // 子订单id
          params.activityCardId = item.activityCardId; // 优惠券id
          params.userAccountId = this.$fission.user.userAccountId;
          params.uploadVerifyProof = item.uploadVerifyProof;
          params.type = 'spike';
        } else if (type === 6) { // 我的集赞
          params.id = item.orderItemId; // 子订单id
          params.collectLikeProductId = item.collectLikeProductId;
          params.type = 'collectAssist';
        } else if (type === 'medal') { // 集章
          params.type = type;
          params.userAccountId = this.$fission.user.userAccountId;
          params.id = this.$fission.activity && this.$fission.activity.tkLiveActivityId ? this.$fission.activity.tkLiveActivityId : '';
        }
        this.$nextTick(()=>{
          const canvas = document.querySelector('#canvas');
          QRCode.toCanvas(canvas, JSON.stringify(params)).then(() => {
          }).catch((err) => {
            console.log(err);
          });
        })
      }
    },
  };
</script>

<style scoped>
  .qrcode{
    border:1px solid #eee;
  }
  #canvas{
    width:200px!important;
    height:200px!important;
  }
  .qrcode-text{
    padding:10px 0;
    text-align:center;
    margin:0;
  }
</style>
